import { CloseIconT1 } from "../../atoms/Icon";
import { PortalTitle } from "../../atoms/Headings";
import { PortalHeaderActions, PortalHeaderContent, StyledPortalHeader } from "./Header.styles";

/**
 * PortalHeader
 *
 * Styled wrapper for portal header content.
 *
 * Usage
 * - Modal
 * - Popover
 *
 * Params
 * - title:
 * - onClose:
 *
 * Returns
 * - React.ReactElement: A StyledPortalHeader element wrapping the provided title and close icon.
 */
export const PortalHeader = ({ title, supplementary, onClose }) => {
  return (
    <StyledPortalHeader>
      <PortalHeaderContent>
        <PortalTitle title={title} />
      </PortalHeaderContent>
      <PortalHeaderActions>
        {supplementary}
        <CloseIconT1 onClickCallback={onClose} />
      </PortalHeaderActions>
    </StyledPortalHeader>
  );
};
